import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { getNoteBySlug } from '../data/notes';
import { useReveal } from '../hooks/useReveal';

function NoteDetailPage() {
  const { slug } = useParams();
  const note = getNoteBySlug(slug);

  useReveal([slug]);

  if (!note) {
    return <Navigate to="/notes" replace />;
  }

  const categories = note.categories.slice(0, 2);

  return (
    <article className="page page--note-detail">
      <div className="container">
        <header className="note-detail__header reveal">
          <Link to="/notes" className="page__back">
            &larr; All notes
          </Link>
          <h1 className="note-detail__title">{note.title}</h1>
          {categories.length > 0 && (
            <div className="note-detail__categories">
              {categories.map((category) => (
                <span key={category} className="note-card__category">
                  {category}
                </span>
              ))}
            </div>
          )}
        </header>

        <div className="note-detail__layout reveal reveal--delay-1">
          <div className="note-detail__content">
            {note.content.map((paragraph) => (
              <p key={paragraph.slice(0, 32)}>{paragraph}</p>
            ))}
          </div>

          <figure className="note-detail__figure">
            <img src={note.image} alt={note.imageAlt} />
          </figure>
        </div>
      </div>
    </article>
  );
}

export default NoteDetailPage;
